<template>
  <button id="menu" class="menu" v-on:click="toggleMenu" v-bind:class="{'active':isActive}">
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
  </button>
</template>

<script>
// 親子関係のないコンポーネントに関数を渡すための設定
import eventHub from '@/main'

export default {
  data() {
    return {
      isActive: false
    }
  },
  created() {
    // 親子関係のないコンポーネントに関数を渡すための設定
    eventHub.$on('closeMenu', this.closeMenu)
  },
  methods: {
    toggleMenu: function() {
      this.isActive = !this.isActive
      if (this.isActive) {
        document.getElementsByTagName('nav')[0].classList.add('open')
      } else {
        document.getElementsByTagName('nav')[0].classList.remove('open')
      }
    },
    closeMenu: function() {
      this.isActive = false
      document.getElementsByTagName('nav')[0].classList.remove('open')
    }
  },
}
</script>

<style lang="scss">
.menu {
  display: none;
  appearance: none;
  position: absolute;
  top: calc(50% - 15px);
  right: 15px;
  width: 30px;
  height: 30px;
  padding: 0;
  background-color: transparent;
  border: none;
  z-index: 2000;
  .bar {
    position: relative;
    display: block;
    width: 20px;
    height: 1px;
    margin: auto;
    background-color: #5a5858;
    transform-origin: 50% 50%;
    transition: all .3s ease;
    z-index: -1;
    &:nth-child(1) {
      transform: translateY(-10px);
    }
    &:nth-child(2) {
      transform: translateY(0px);
    }
    &:nth-child(3) {
      transform: translateY(10px);
    }
  }
  &.active {
    .bar {
      &:nth-child(1) {
        transform: translate(0, 1px) rotate(45deg);
      }
      &:nth-child(2) {
        opacity: 0;
      }
      &:nth-child(3) {
        transform: translate(0, -1px) rotate(-45deg);
      }
    }
  }
  @include mq {
    display: block;
  }
}
</style>